import script from "./SliderPrincipalHome.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderPrincipalHome.vue?vue&type=script&setup=true&lang=js"

import "./SliderPrincipalHome.vue?vue&type=style&index=0&id=a1ec73ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1ec73ea"]])

export default __exports__